import { z } from 'zod';
import { BrandProvider } from 'store/brands';
import { Translations } from 'types/Common';
import { ContentLanguage, Currency } from 'types/general';
import { adminCardsFiltersSchema } from './admin-cards.schemas';

export const adminCardStatuses = [
  'enabled',
  'disabled_by_melp',
  'disabled_by_provider',
] as const;
export type AdminCardStatus = (typeof adminCardStatuses)[number];

export const adminCardPriceTypes = ['fixed', 'range'] as const;
export type AdminCardPriceType = (typeof adminCardPriceTypes)[number];

export interface AdminBaseCard {
  id: string;
  sequence: number;
  externalId: string;
  status: AdminCardStatus;
  brand: { id: string; name: string } | null;
  countries: string[];
  provider: BrandProvider;
  ordersCount: number;
  priceType: AdminCardPriceType;
  language: Uppercase<ContentLanguage>;
  resolutionDuration: number;

  faceValues: number[];
  faceValuesLabels: string[];
  faceValueMin: number;
  faceValueMax: number;
  faceValueCurrency: Currency;

  purchasePriceDiscountPercentage: number;
  purchasePriceDiscountFee: number;
  purchasePriceCurrency: Currency;

  melpFeeEuro: number;
  melpFeePercentage: number;

  createdAt: string;
  updatedAt: string | null;
}

export interface AdminCard extends AdminBaseCard {
  supportedLanguages: Uppercase<ContentLanguage>[];
  content: Translations<{
    label: string;
    description: string;
    terms: string;
    redeemInstructions: string;
  }>;
  prices: Array<{
    faceValue: number;
    content: Translations<{ faceValuesLabel: string }>;
  }>;
  raw: string;
}

export type AdminCardsFilters = z.infer<typeof adminCardsFiltersSchema>;
